import React, { useEffect,useState } from 'react';

import { GetSimpleDateTimeFromJDateTime } from "../../../components/common/Common";
import cancelIcon from "../../../img/icon/icon-cancel.svg";

const AttendanceOK = ({varPopupAttendanceOK,setPopupAttendanceOK,onCloseInitHandler}) => {
  const [varAttendanceMessage,setAttendanceMessage] = useState('');

  useEffect(() => {
    setAttendanceMessage(GetSimpleDateTimeFromJDateTime());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varPopupAttendanceOK]);

  return (
    <div className="layer-pop login-pop02" style={varPopupAttendanceOK?{display:"block"}:{display:"none"}}>
      <div className="layer-con">
        <div className="layer-hd">
          <div className="tit">출석 인증 성공</div>
          <div className="close-layer" onClick={()=>setPopupAttendanceOK(false)}><img src={cancelIcon} alt=""/></div>
          </div>
        <div className="info">
          <div className="info">{varAttendanceMessage} <br/>출석체크가 완료되었습니다.</div>
          <div className="form-contoller bt-btn">
            <button className="form-contoller-btn btn-yes" onClick={(e)=>onCloseInitHandler(e,0)}>확인</button>
          </div>
        </div>
      </div>
    </div>
  )
}
export default AttendanceOK;